import qs from 'query-string';
import { partial } from 'lodash';
import React, { useState, useEffect } from 'react';
import useEventListener from 'use-event-listener';
import { useMedia } from 'react-use-media';

import { assetUrl } from '~/helpers';
import Modal from '~/App/Components/Modal';
import CloseIcon from '~/Share/components/Atoms/CloseIcon';
import CheckIcon from './CheckIcon';

export interface UpgradeProps {
  referer: string;
  redirect: string;
  onOpen?(): void;
}

const Upgrade = ({ referer, redirect, onOpen }: UpgradeProps) => {
  const [isOpen, setOpen] = useState(false);

  useEventListener('upgrade-modal::open', () => {
    setOpen(true);
  });

  useEffect(() => {
    isOpen && onOpen?.();
  }, [isOpen]);

  const isMobile = useMedia({
    maxWidth: 768,
  });

  const modalProps = {
    styles: {
      panel: ({ base }) => ({
        ...base,
        width: !isMobile ? 655 : 'auto',
        margin: !isMobile ? 0 : '0 20px',
        position: 'relative',
        border: 'unset',
        overflow: 'hidden',
      }),
      content: ({ base }) => ({
        ...base,
        maxWidth: !isMobile ? 695 : 660,
      }),
      overlay: ({ base }) => ({
        ...base,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }),
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setOpen(false)}
      hideActions={true}
      {...modalProps}
    >
      <CloseIcon onClick={partial(setOpen, false)} />
      <img
        className='upgrade-bear'
        src={assetUrl('assets/images/joro/upgrade.png')}
      />
      <div id='upgrade-modal'>
        <h1>
          Don’t let limits get in the way of your business, upgrade to the
          Grrrowth plan today.
        </h1>
        <ul>
          <li>
            <CheckIcon />
            Send to more than three
          </li>
          <li>
            <CheckIcon />
            Unlimited video
          </li>
          <li>
            <CheckIcon />
            25 custom integrations
          </li>
          <li>
            <CheckIcon />
            25 message templates
          </li>
          <li>
            <CheckIcon />
            Priority support
          </li>
          <li>
            <CheckIcon />
            Ability to export data
          </li>
        </ul>
        <a
          className='btn btn-primary'
          href={`/billing/pricing?${qs.stringify({
            ref: referer,
            redirect,
          })}`}
        >
          Upgrade now
        </a>
      </div>
    </Modal>
  );
};

export default Upgrade;
